<template>
  <div class="fixed inset-0">
    <div class="relative size-full">
      <div
        v-if="!isShowingAnimation"
        class="absolute inset-x-0 bottom-0 flex h-64 items-center justify-center"
      >
        <IconLoading
          class="size-12 animate-spin text-primary"
        />
      </div>

      <div
        v-if="hasAnimation"
        id="splash-animation-container"
        class="size-full"
      />

      <img
        v-else
        :src="splashImageSrc"
        class="size-full object-cover"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Lottie from "lottie-web"
import splashAnimationUrl from "@brandassets/splash-animated.json?url"
import splashImageSrc from "@brandassets/splash.png"

const { canHideSplashScreen } = useSplashScreenState()

const hasAnimation = false // Currently no organizations use an animated splash screen
const isShowingAnimation = ref(false)
const onAnimationComplete = () => {
  isShowingAnimation.value = false
}

onMounted(async () => {
  if (hasAnimation) {
    const containerEl = document.querySelector(
      "#splash-animation-container"
    )
    if (!containerEl) return
    const animation = Lottie.loadAnimation({
      container: containerEl,
      renderer: "canvas",
      loop: false,
      autoplay: true,
      path: splashAnimationUrl,
    })

    animation.addEventListener(
      "complete",
      onAnimationComplete
    )
    animation.addEventListener(
      "data_failed",
      onAnimationComplete
    )
    animation.setSubframe(false)
    isShowingAnimation.value = true
  } else {
    hideSplash()
  }
})

whenever(
  () =>
    canHideSplashScreen.value && !isShowingAnimation.value,
  () => hideSplash()
)

const hideSplash = async () => {
  document.querySelector("#splash")?.remove()
}
</script>
